import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Routes } from '../../../routes/routes';
import { TertiaryButtonComponent } from '../../../views/shared/components/tertiary-button/tertiary-button.component';
import { BaseButtonSizeEnum } from '../../../views/shared/components/base-button/base-button-size.enum';

@Component({
  selector: 'app-mp-access-restricted',
  standalone: true,
  imports: [TertiaryButtonComponent],
  templateUrl: './mp-access-restricted.component.html',
  styleUrls: ['./mp-access-restricted.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MpAccessRestrictedComponent {
  private router = inject(Router);

  protected readonly contactUrl = Routes.sppContact();
  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;

  public backToLogIn(): void {
    this.router.navigate(['/auth/sign-in']).then();
  }
}
